<template>
  <b-table
    v-bind="$attrs"
    v-on="$listeners"
    :items="items"
    :fields="fields"
    :busy="busy"
    primary-key="id"
    table-class="table-baseline"
    thead-class="d-none"
    show-empty
  >
    <template #table-busy>
      <div class="text-center">
        <b-spinner small/>
      </div>
    </template>
    <template #cell(thumbnail)="{ value, item }">
      <router-link
        :to="{name: 'search', query: {q: item.identifier}, hash: `#${item.identifier}`}"
        :title="item.identifier"
      >
        <img :src="value" alt=" " loading="lazy" class="thumb-image">
      </router-link>
    </template>
    <template #cell(annotation)="{ value }">
      <div class="d-flex">
        <div class="flex-fill text-truncate w-0" :title="value">
          {{value}}
        </div>
      </div>
    </template>
  </b-table>
</template>

<script>
import { capitalize } from 'lodash'

import { currency } from '@/utils/currency.js'
import { datetime } from '@/utils/datetime.js'

export default {
  name: 'ArtUsages',
  inheritAttrs: false,
  props: {
    busy: Boolean,
    items: Array,
  },
  data() {
    return {
      fields: [
        {key: 'thumbnail', label: '', class: 'column-narrow', tdClass: 'p-0 align-middle'},
        {key: 'annotation', formatter: formatAnnotation, },
        {
          key: 'date_shipped',
          label: 'Date',
          formatter: (val) => datetime(val, 'shorter'),
          tdAttr: (val) => ({title: datetime(val)}),
          class: 'text-right column-narrow',
          tdClass: 'small text-muted',
        },
        {
          key: 'amount_due',
          label: 'Amount',
          class: 'text-right text-tabular column-narrow',
          formatter: i => currency(i, 100),
        },
      ],
    }
  },
}

function removeDecimal(val) {
  return val?.replace(/\.00/g, '')
}
export function formatAnnotation(val) {
  return removeDecimal(capitalize(val))
}
</script>

<style lang="scss" scoped>
.thumb-image {
  display: block;
  max-width: 72px;
  max-height: 48px;
  image-orientation: from-image;
  .table-sm & {
    max-height: 32px;
  }
}
</style>
